import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { catchError, EMPTY, first } from 'rxjs';

import { ManageRolesContent } from 'src/app/interfaces/profile.interface';
import { RoleInfo } from 'src/app/models/role-info.model';
import { NotificationContextAttributesService } from 'src/app/notifications/notifications-context-attributes.service';
import { NotificationService } from 'src/app/notifications/notifications.service';
import { UserTypeState } from '../user-type.state';

@Component({
  selector: 'app-individual-user',
  templateUrl: './individual-user.component.html',
  styleUrls: ['./individual-user.component.scss'],
})
export class IndividualUserComponent extends UserTypeState {
  @Input({ required: true }) public userRolesInfo: RoleInfo[] = [];

  @Output() public manageRoles: EventEmitter<ManageRolesContent> = new EventEmitter<ManageRolesContent>();

  private notificationService = inject(NotificationService);
  private modalAttributesService = inject(NotificationContextAttributesService);

  public openRoleSelectionModal(): void {
    this.notificationService
      .dialogIndividualRoleSelect({
        roles: this.userRolesInfo,
        buttons: this.modalAttributesService.getUserRoleSelectionAttr,
      })
      .pipe(
        first(),
        catchError(() => EMPTY),
      )
      .subscribe((roles: RoleInfo[]) => {
        if (roles && roles instanceof Array) {
          this.manageRoles.emit({ roles, formsContent: this.formsContent });
        }
      });
  }
}
